enum ActionsEnum {
    PartnerReferralDealAdd = 'PARTNER_REFERRAL/DEAL/ADD',
}

export default ActionsEnum;
